import { useMutation } from '@tanstack/react-query'
import { getBespokeFreeTexts } from 'sagas/network'
import { stringifyQueryParams } from 'utils'

import { Queries } from 'api/queries.enum'
import {
    GetBespokeFreeTextsParams,
    GetBespokeSingleQuestionResponse,
} from 'api/actions/analyze/freeTexts/freeTextsActions.types'

export const useGetBespokeSingleQuestion = (params?: GetBespokeFreeTextsParams) => {
    const mutation = useMutation<GetBespokeSingleQuestionResponse, Error, GetBespokeFreeTextsParams>({
        mutationKey: [Queries.getFreeTexts, params],
        mutationFn: (params) => getBespokeFreeTexts(stringifyQueryParams(params)),
    })

    return mutation
}
